import script from "./TelegramMessagePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./TelegramMessagePreview.vue?vue&type=script&setup=true&lang=ts"

import "./TelegramMessagePreview.vue?vue&type=style&index=0&id=1883ea62&lang=css"

const __exports__ = script;

export default __exports__